import React from "react";
import { Logo } from "assets/icons";
import "./styles.scss";

/**
 * Tela cheia de carregamento com a marca do sistema — usada no boot do app,
 * no callback de login e nos redirects que aguardam permissões carregarem.
 */
const LoadingScreen = ({ message = null }) => (
    <div className="cp-loading-screen" role="status" aria-live="polite">
        <Logo className="cp-loading-logo" aria-label={process.env.REACT_APP_NAME || "CLM"} />
        <div className="cp-loading-dots" aria-hidden="true">
            <span />
            <span />
            <span />
        </div>
        {message && <p className="cp-loading-message">{message}</p>}
    </div>
);

export default LoadingScreen;
